import { http } from '../../../../api/http';
import type { Lote } from '../types/lote.types';

export const loteService = {
  async getAll(idArticulo?: number): Promise<Lote[]> {
    const params = idArticulo ? `?idArticulo=${idArticulo}` : '';
    const response = await http.get(`/inventario/lote${params}`);
    return response.data;
  },

  async getById(id: number): Promise<Lote> {
    const response = await http.get(`/inventario/lote/${id}`);
    return response.data;
  },

  async save(lote: Lote): Promise<Lote> {
    const response = await http.post('/inventario/lote', lote);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await http.delete(`/inventario/lote/${id}`);
  },

  async getProximosAVencer(diasAlerta?: number): Promise<Lote[]> {
    const params = diasAlerta ? `?diasAlerta=${diasAlerta}` : '';
    const response = await http.get(`/inventario/lote/proximos-vencer${params}`);
    return response.data;
  },
};
